module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "HelpPage"
  }, [_c('header-component'), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.legacySystemHTML)
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "u-shadow-v35 g-bg-white rounded g-py-0 g-pb-35"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('p', {
    staticClass: "g-color-text-light-v1 g-font-size-16 g-font-weight-500"
  }), _vm._v(" "), _c('a', {
    staticClass: "btn g-font-size-16 u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-35 g-py-13",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleBack('/')
      }
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('a', {
    staticClass: "btn g-font-size-16 u-shadow-v33 g-color-white g-bg-primary g-bg-main--hover g-rounded-30 g-px-35 g-py-13",
    on: {
      "click": function($event) {
        return _vm.RedirectToSignUp()
      }
    }
  }, [_vm._v("Sign Up")])])])]), _vm._v(" "), _c('footer-component')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container g-py-40",
    attrs: {
      "id": "contactDiv"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 pp_image g-px-0"
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "width": "100%",
      "height": "0",
      "padding-bottom": "56.25%"
    }
  }, [_c('iframe', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "0",
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": "//www.youtube-nocookie.com/embed/b-_NCXXtLe4?showinfo=0&rel=0&modestbranding=1&autoplay=1&mute=1",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-65e2a1f5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65e2a1f5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/Demo.vue
// module id = 516
// module chunks = 3